import Dialog from "../../components/Dialog";
import { useState } from "react";
import SentenceTranslationForm from "./SentenceTranslationForm";

export default function SentenceTranslationDialog({ visible, hide, item, preloaded, ...props }) {
	const [loading, setLoading] = useState(false);

	return (
		<Dialog
			title={item ? "Update Sentence Translation" : "Add Sentence Translation"}
			visible={visible} onCancel={hide} closable={!loading}
		>
			<SentenceTranslationForm
				{...props} id={item?.id}
				item={preloaded ? item : undefined}
				submitting={loading}
				setSubmitting={l => setLoading(l)}
				onCancel={hide}
			/>
		</Dialog>
	)
}
